import request from '@/utils/request'
const sortApi = {
  queryItemCategoryList: (params) => {
    return request({
      url: `/item/category/list`,
      method: 'get',
      params
    })
  },
  queryItemTagShowInCategoryList: () => {
    return request({
      url: `/item/tag/show-in-category/list`,
      method: 'get'
    })
  },
  queryItemList: (params) => {
    return request({
      url: `/item/list`,
      method: 'get',
      params
    })
  },
  // 秒杀商品详情
  querySpikeList: (params) => {
    return request({
      url: `/activity/seckill/list`,
      method: 'get',
      params
    })
  },
  // 折扣商品详情
  queryDiscountList: (params) => {
    return request({
      url: `/activity/item`,
      method: 'get',
      params
    })
  },
  // 秒杀商品下单
  getSubmitSpikeOrder: (data) => {
    return request({
      url: '/activity/seckill/submit',
      method: 'post',
      data
    })
  },

  queryItemInfo: (params) => {
    return request({
      url: `/item/info/${params.itemId}`,
      method: 'get'
    })
  },

  getCassLoginHelpImg: (data) => {
    return request({
      url: '/public/apply/image',
      method: 'post',
      data
    })
  },
  // 兑换课程次数
  getItemOrderCount: (params) => {
    return request({
      url: `/item/order/count/${params.itemId}`,
      method: 'get'
    })
  },
  // 取消收藏
  removeFavorite: (data) => {
    return request({
      url: '/favorite/remove',
      method: 'post',
      data
    })
  },

  // 添加收藏
  addFavorite: (data) => {
    return request({
      url: '/favorite/add',
      method: 'post',
      data
    })
  },
  // 取消点赞
  removeSupport: (data) => {
    return request({
      url: '/item/cancel-support',
      method: 'post',
      data
    })
  },

  // 添加点赞
  addSupport: (data) => {
    return request({
      url: '/item/support',
      method: 'post',
      data
    })
  },
  // 加入购物车
  addCar: (data) => {
    return request({
      url: '/cart/add',
      method: 'post',
      data
    })
  },
  // 获取elearning平台访问token
  getElearningToken: (params) => {
    return request({
      url: '/elearning/token',
      method: 'get',
      params
    })
  },
  // 客户信息获取
  getClientInfo: (params) => {
    return request({
      url: '/client/info',
      method: 'get',
      params
    })
  },
  queryTag: (params) => {
    return request({
      url: '/item/tag/query',
      method: 'get',
      params
    })
  }

}

export default sortApi
